import { ClockFormat } from '@lio/rule-engine';
import {
  FontSize,
  GridColumn,
  OfferingThemeMode,
  TLayoutPreferences,
  TWalkthroughs,
  UserStoreSlice,
} from '@store/types/UserStoreSlice.type';

import { StateCreator } from 'zustand';

const initialState = {
  currentUser: undefined,
  roles: [],
  userAuth: {
    payerAccountType: [],
    hasPayerProfile: false,
    isAdmin: false,
    isPortalAdmin: false,
    isUnderwriter: false,
    isLIOContractor: false,
    isBroker: false,
    isJrOps: false,
    isSrOps: false,
    isLioSales: false,
    isInternalUser: false,
    isInternalWithoutSales: false,
    isCSR: false,
    isCustomerUser: false,
    isAuthenticated: false,
    isLoading: true,
    isError: false,
  },

  layoutPreferences: {
    offeringGridColumns: GridColumn.OFFERING_DEFAULT,
    fontSize: FontSize.DEFAULT,
    offeringColorMode: OfferingThemeMode.DEFAULT,
    clockFormat: ClockFormat.TwelveHour,
  },

  walkthroughs: {},
};

export const createUserStoreSlice: StateCreator<UserStoreSlice, [], [], UserStoreSlice> = (set) => ({
  ...initialState,
  setUserRoles: (v) =>
    set((state) => {
      return {
        ...state,
        ...v,
      };
    }),
  setLayoutPreferences: (layoutPreferences: TLayoutPreferences) =>
    set((state) => ({
      ...state,
      layoutPreferences,
    })),
  setWalkthroughs: (walkthroughs: TWalkthroughs) =>
    set((state) => ({
      ...state,
      walkthroughs,
    })),
});
